import { Button, Modal, TextStyle } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { toast } from '@nile/components';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

function SaveContainer(props) {
  const {
    hideSave,
    handleSave,
    saveAsOnly,
    disabledSave,
    fromReport,
    submitActionLoading,
    originalData,
    layoutRef
  } = props;

  const [saveConfirmation, setSaveConfirmation] = useState(false);

  const scrollToWidget = () => {
    setTimeout(() => {
      layoutRef.current.scrollTop = layoutRef.current.scrollHeight + 1000;
    }, 2000);
  };

  if (!originalData) {
    return (
      <>
        <Button
          primary
          onClick={() => {
            handleSave();
          }}
          loading={submitActionLoading}
          icon={<SVGIcon name="Save" color="white" />}
          disabled={disabledSave}
        >
          <FormattedMessage id="common.save" />
        </Button>
      </>
    );
  }

  return (
    <>
      {!hideSave && (
        <>
          {saveAsOnly ? (
            <Button
              primary
              onClick={() => {
                handleSave(() => {
                  toast('success', 'reports.widget.updateWidget.success');
                }),
                  true;
              }}
              loading={submitActionLoading}
              icon={<SVGIcon name="Save" color="white" />}
              disabled={disabledSave}
            >
              <FormattedMessage id="app.saveas.btn" />
            </Button>
          ) : (
            <Modal
              activator={
                <Button
                  primary
                  onClick={() => {
                    setSaveConfirmation(true);
                  }}
                  loading={submitActionLoading}
                  icon={<SVGIcon name="Save" color="white" />}
                  disabled={disabledSave}
                  connectedDisclosure={{
                    actions: [
                      {
                        content: (
                          <div className="fx actr g10">
                            <SVGIcon name="Save" />
                            <TextStyle>
                              <FormattedMessage id="app.saveas.btn" />
                            </TextStyle>
                          </div>
                        ),
                        disabled: disabledSave,
                        onAction: () => {
                          handleSave(() => {
                            toast(
                              'success',
                              fromReport
                                ? 'reports.widget.cloneAndUpdateLayout.success'
                                : 'reports.widget.cloneWidget.success'
                            );
                            scrollToWidget();
                          }, true);
                        }
                      }
                    ]
                  }}
                >
                  <FormattedMessage id="common.save" />
                </Button>
              }
              open={saveConfirmation}
              onClose={() => setSaveConfirmation(false)}
              variant="confirmation"
              title={<FormattedMessage id="app.general.toast.warning" />}
              primaryAction={{
                content: (
                  <div className="flex actr">
                    <SVGIcon name="Save" />
                    <div className="ml8">
                      <FormattedMessage id="common.save" />
                    </div>
                  </div>
                ),
                onAction: () => {
                  handleSave(() => {
                    setSaveConfirmation(false);
                    toast('success', 'reports.widget.updateWidget.success');
                  });
                }
              }}
              secondaryActions={[
                {
                  content: <FormattedMessage id="common.cancel" />,
                  onAction: () => setSaveConfirmation(false)
                }
              ]}
            >
              <FormattedMessage id="reports.widget.save.modal.description" />
            </Modal>
          )}
        </>
      )}
    </>
  );
}

export default SaveContainer;
